import { Assets } from 'pixi.js';
import { CARD_ELEMENT_ID } from '../CommonAssets';

export class CardData {
    constructor(tokenId, imageUrl, attributes, playerId){
        this.vertexData = {};
        this.tokenId = tokenId;
        this.imageUrl = imageUrl.replace('auto=format', '');
        this.attributes = attributes;
        this.playerId = playerId;
        this.rotateCount = 0;
    }

    static CreateOnchainCardData(onchainCard, playerId)
    {
        return new CardData(
            onchainCard.tokenId,
            onchainCard.image,
            JSON.parse(onchainCard.traits),
            playerId
        );
    }

    static CreateReplaceCardData(replaceCard, playerId)
    {
        return new CardData(
            replaceCard.id,
            '',
            [
                {
                    'trait_type': 'MOKUTON',
                    'value': replaceCard.element1
                },
                {
                    'trait_type': 'KATON',
                    'value': replaceCard.element2
                },
                {
                    'trait_type': 'DOTON',
                    'value': replaceCard.element3
                },
                {
                    'trait_type': 'KINTON',
                    'value': replaceCard.element4
                },
                {
                    'trait_type': 'SUITON',
                    'value': replaceCard.element5
                }                
            ],
            playerId
        );
    }

    async Init()
    {
        await this.loadAssets();
        await this.setElements(this.tokenId);
    }

    async loadAssets()
    {
        const key = `token_${this.tokenId}`;
        if(this.imageUrl && !Assets.cache.has(key)){
            Assets.add(key, this.imageUrl);
            await Assets.load(key).then();
        }
    }

    async setElements(tokenId)
    {
        // SHA-1ハッシュ化でtokenIdを40桁の16進数に変換
        const data = new TextEncoder().encode(tokenId);
        const hashBuffer = await crypto.subtle.digest('SHA-1', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

        const elementValueMap = {};
        this.attributes.forEach(attribute => {
            if(CARD_ELEMENT_ID[attribute.trait_type])
            {
                elementValueMap[CARD_ELEMENT_ID[attribute.trait_type]] = attribute.value;
            }
        });

        let sortingArray = [];
        for(let i = 0; i < 5; i++)
        {
            sortingArray.push({
                'elementId' : i + 1,
                'elementValue' : elementValueMap[i + 1],
                // 40桁の16進数から8桁ずつ切り出して10進数に変換
                'sortingValue' : parseInt(hashHex.substring(i * 8, i * 8 + 8), 16),
            });
        }

        // sortingValueの昇順に並べ替える
        sortingArray = sortingArray.sort((a, b) => {
            if(a.sortingValue == b.sortingValue) return 0;
            if(a.sortingValue > b.sortingValue)
            {
                return 1;
            }
            else
            {
                return -1;
            }
        });

        for(let vertex = 0; vertex < sortingArray.length; vertex++)
        {
            this.vertexData[vertex] = {
                'elementId' : sortingArray[vertex].elementId,
                'elementValue' : sortingArray[vertex].elementValue,
            };
        }
    }

    setRotateCount(count)
    {
        // TODO: 最大値が4であることの制御
        this.rotateCount = count;
    }

    calcRotatedVertex(vertex)
    {
        let rotatedVertex = vertex - this.rotateCount;
        if(rotatedVertex < 0)
        {
            rotatedVertex += 5;
        }
        return rotatedVertex;
    }

    getVertexElementId(vertex)
    {
        const rotatedVertex = this.calcRotatedVertex(vertex);
        return this.vertexData[rotatedVertex].elementId;
    }

    getVertexValue(vertex)
    {
        const rotatedVertex = this.calcRotatedVertex(vertex);
        return this.vertexData[rotatedVertex].elementValue;
    }
}
